import { render } from "./SimpleNoteCreateTopSection.vue?vue&type=template&id=1f580a8a&scoped=true"
import script from "./SimpleNoteCreateTopSection.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateTopSection.vue?vue&type=script&lang=js"

import "./SimpleNoteCreateTopSection.vue?vue&type=style&index=0&id=1f580a8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f580a8a"]])

export default __exports__